{
  "name": "cockpit-ui",
  "version": "2.2.0",
  "scripts": {
    "ng": "ng",
    "start": "ng serve --port 4202",
    "build": "ng build",
    "clean": "rm -rf dist/ node_modules/ package-lock.json && npm i",
    "watch": "ng build --watch --configuration development",
    "test": "jest --verbose",
    "test:coverage": "jest --coverage",
    "test:watch": "jest --watch",
    "test-headless": "jest --runInBand --detectOpenHandles --forceExit --ci --coverage"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^17.3.11",
    "@angular/cdk": "17.3.10",
    "@angular/common": "^17.3.11",
    "@angular/compiler": "^17.3.11",
    "@angular/core": "^17.3.11",
    "@angular/forms": "^17.3.11",
    "@angular/material": "^17.3.10",
    "@angular/material-moment-adapter": "^17.2.9",
    "@angular/platform-browser": "^17.3.11",
    "@angular/platform-browser-dynamic": "^17.3.11",
    "@angular/router": "^17.3.11",
    "@hygie31/keycloak-authentication": "^0.0.1",
    "@hygie31/ngx-hygie31-kit-ui-17": "0.1.38",
    "@ngx-translate/core": "^14.0.0",
    "@ngx-translate/http-loader": "^7.0.0",
    "fast-xml-parser": "^4.4.1",
    "jspdf": "^2.5.2",
    "jspdf-autotable": "^3.8.4",
    "keycloak-angular": "^15.3.0",
    "powerbi-client": "^2.22.2",
    "rxjs": "^7.8.0",
    "tslib": "^2.3.0",
    "zone.js": "~0.14.3"
  },
  "devDependencies": {
    "@angular-builders/jest": "^17.0.3",
    "@angular-devkit/build-angular": "^17.3.8",
    "@angular/cli": "~17.3.8",
    "@angular/compiler-cli": "^17.3.11",
    "@types/jest": "^29.5.12",
    "jest": "^29.7.0",
    "jest-preset-angular": "^14.1.1",
    "ts-jest": "^29.1.4",
    "typescript": "~5.4.5"
  }
}
